import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import PDAnimation from "./PDAnimation";

export default function PurpleDoorHome() {
    const authState = useSelector((state) => state.authReducer);
    const userName = authState?.user?.name;
    const [showDoor, setShowDoor] = useState(true);
    
    const [offlineData, setOfflineData] = useState("");
    // useEffect(() => {
    //     const testOffline = async () => {
    //         await saveData("test", {
    //             name: "Purple Door",
    //             date: new Date(),
    //         });

    //         const data = await getData("test");
    //         setOfflineData(JSON.stringify(data));
    //         // console.log("Offline Data:", data);
    //     };

    //     testOffline();
    // }, []);

    return (
        <div className="bg-[#0b0f19] text-white flex flex-col">
            {showDoor && (
                <PDAnimation
                    msg={`Welcome: ${userName}`}
                    onComplete={() => setShowDoor(false)}
                />
            )}
            {/* FOOTER */}
            <footer className="relative z-10 bg-gray-900 border-t border-gray-500 py-2 mt-2">
            <div className="mx-auto px-3 flex flex-col items-center">
                <div className="text-xs text-purple-200">
                © 2026 Think5Whys Global DeepTech Solutions Private Limited.
                </div>
                <div className="text-xs text-purple-200">
                A DPIIT Recognized Deeptech Startup.
                </div>
                <div className="flex flex-wrap gap-4 text-xs">
                <Link to="/about-us" className="hover:text-teal-300 text-gray-200">About</Link>
                <Link to="/privacy-policy" className="hover:text-teal-300 text-gray-200">Privacy Policy</Link>
                <Link to="/terms-of-use" className="hover:text-teal-300 text-gray-200">Terms of Use</Link>
                <Link to="/contact-us" className="hover:text-teal-300 text-gray-200">Contact</Link>
                </div>
            </div>
            </footer>
        </div>
    );
}